import { useIsMobile } from '@energiebespaarders/hooks';
import { Box } from '@energiebespaarders/symbols';
import { Image } from 'react-datocms';
import config from '~/config';
import type {
  dummy_dummy_content,
  dummy_dummy_content_ImageBlockRecord,
  dummy_dummy_content_StructuredTextBlockRecord,
} from '~/types/generated/cms/dummy';
import type { getLongReadOrProductBySlug_allProductPages } from '~/types/generated/cms/getLongReadOrProductBySlug';
import DatoPage from '../DatoCms/DatoPage';
import TypedStructuredText from '../DatoCms/TypedStructuredText';
import ProductHero from '../_cmsBlocks/ProductHero';
import type { BlockRendererOverrides } from '../DatoCms/BlockRenderer';

interface Props {
  page: getLongReadOrProductBySlug_allProductPages;
}
const ImageBlockRecordOverride: React.FC<{
  block: dummy_dummy_content;
  removePadding?: boolean;
}> = ({ block, removePadding }) => {
  const isMobile = useIsMobile();
  return (
    <Box py={removePadding ? 0 : [3, 4, 5, 10]} px={removePadding ? 0 : [2, 3, 4, 2, 0]}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <Image
        style={{ borderRadius: 6, maxHeight: isMobile ? 240 : 420 }}
        objectFit="cover"
        data={(block as dummy_dummy_content_ImageBlockRecord).image!.responsiveImage!}
      />
    </Box>
  );
};

const ProductPageOverrides: BlockRendererOverrides = {
  ImageBlockRecord: ImageBlockRecordOverride,
  StructuredTextBlockRecord: ({ block }) => {
    return (
      <Box py={[3, 4, 5, 10]} px={[2, 3, 4, 2, 0]}>
        <TypedStructuredText
          data={(block as dummy_dummy_content_StructuredTextBlockRecord).structuredText}
          overrides={{
            ImageBlockRecord: props => ImageBlockRecordOverride({ ...props, removePadding: true }),
          }}
        />
      </Box>
    );
  },
};

const constructCanonicalUrl = (page: getLongReadOrProductBySlug_allProductPages) => {
  const product = page.slug;
  const parent = page.parentPage?.slug || '';

  return `${config.urls.defaultBaseURL}/woning-verduurzamen/product/${
    parent ? `${parent}/` : ''
  }${product}`;
};

const ProductPage: React.FC<Props> = ({ page }) => {
  return (
    <DatoPage
      content={page.content}
      metaTags={{ metaTags: page.seo, canonicalUrl: constructCanonicalUrl(page) }}
      blockRendererOverrides={ProductPageOverrides}
    >
      <ProductHero block={page.hero[0]} />
    </DatoPage>
  );
};

export default ProductPage;
